import React, { memo } from 'react';

import { Box } from '../Box/Box';
import { Tooltip } from '../Tooltip/Tooltip';
import { StepState } from './types';
import { getStepStateConfig } from './utils';

interface Props {
  label: string;
  state: StepState;
}

export const Bar = memo(({ label, state }: Props) => {
  const { bgCondensed } = getStepStateConfig(state);
  return (
    <Tooltip tooltip={label}>
      <Box
        data-testid="bar"
        bg={bgCondensed}
        flex="none"
        h="step.bar.height"
        w="step.bar.width"
      />
    </Tooltip>
  );
});
